import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-pill-telephone',
    templateUrl: './pill-telephone.component.html',
    styleUrls: ['./pill-telephone.component.scss'],
})
export class PillTelephoneComponent implements OnInit {
    @Input() contactPhonenumber: string;

    constructor() {}

    ngOnInit(): void {}
}
